import React, { useState } from "react";
import { loginBack } from "helper/constant";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import RegisterEnhancer from "./enhancer/RegisterEnhancer";
import { merchantRegister } from "services/userProfileServices";
import { connect } from "react-redux";
import navigationAction from "redux/navigation/actions";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Loader from "components/Loader";
import { Modal } from "reactstrap";
import OTPModal from "./OTPModal";
import svgLogo from "../../../assets/images/logo.svg";
import SideImage from "./SideImage";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const { success, error } = navigationAction;
const Register = props => {
  let {
    isValid,
    handleSubmit,
    handleChange,
    handleBlur,
    errors,
    touched,
    submitCount,
    values,
    setValues
  } = props;
  const [togglePassword, setTogglePassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otpModal, setOtpModal] = useState(false);
  const [registeredUser, setRegisteredUser] = useState({});

  let closeModal = () => {
    setOtpModal(false);
  };

  const handleRegister = async e => {
    e.preventDefault();
    handleSubmit();
    console.log(isValid, "isValid", errors);
    if (isValid) {
      setLoading(true);
      let data = {
        ...values,
        is_superadmin: false
      };
      await merchantRegister(data).then(res => {
        if (res.success) {
          success(res.message);
          setRegisteredUser(res.data);
          setOtpModal(true);
          console.log(otpModal, "otpModal");

          // props.history.push("/login");
          setLoading(false);
        } else {
          error(res.message);
          setLoading(false);
        }
      });
    }
  };

  const loginContainer = {
    backgroundImage: `url(${loginBack})`,
    backgroundPosition: "center center",
    backgroundSize: "cover",
    position: "fixed",
    overflow: "auto",
    top: 0,
    bottom: 0
  };

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };

  return (
    <div className="login-row">
      <div className="login-box">
        <div className="form-container register-form">
          {/* <div className="login-icon">
            <img src={iconDemo} alt="icon" height="100px" />
          </div> */}
          <div className="logo">
            <img src={svgLogo} alt="" />
          </div>
          <div className="login-title">Create Account</div>
          <form>
            <div className="row"></div>
            <div className="form-group">
              {/* <label>Name</label> */}
              <input
                type="text"
                className="form-control react-form-input"
                id="name"
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Name"
              />
              <Error field="name" />
            </div>

            {/* <div className="form-group">
              <label>Last Name</label>
              <input
                type="text"
                className="form-control react-form-input"
                id="lastname"
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Last Name"
              />
              <Error field="lastname" />
            </div> */}
            <div className="form-group">
              {/* <label>Email</label> */}
              <input
                type="email"
                className="form-control react-form-input"
                id="email"
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Email"
              />
              <Error field="email" />
            </div>

            <div className="form-group">
              {/* <label>Phone Number:</label> */}
              <input
                type="text"
                className="form-control react-form-input"
                id="phone_number"
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Phone Number"
              />
              <Error field="phone_number" />
            </div>

            <div className="form-group  mb-3">
              {/* <label htmlFor="">Password</label> */}
              <div className="input-group show-hide-password">
                <input
                  type={togglePassword ? "text" : "password"}
                  className="form-control react-form-input"
                  id="password"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Confirm Password"
                />
                <div className="register-input input-group-append">
                  {togglePassword ? (
                    <VisibilityOff onClick={() => setTogglePassword(false)} />
                  ) : (
                    <Visibility
                      onClick={() => {
                        setTogglePassword(true);
                        // console.log("clicked");
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
            <Error field="password" />

            <div className="form-check mtb-16">
              <input
                type="checkbox"
                className="form-check-input"
                id="exampleCheck1"
                checked={values.terms_condition}
                onChange={e => {
                  setValues({ ...values, terms_condition: e.target.checked });
                }}
              />
              <label
                className="form-check-label register-privacy-text"
                htmlFor="exampleCheck1"
              >
                Agree to{" "}
                <Link to="/terms-and-conditions">terms & condition </Link>&{" "}
                <Link to="/privacy-policy">privacy policy</Link>
              </label>
            </div>
            <Error field="terms_condition" />

            <button
              className="btn form-button siteenterbutton mt-3"
              onClick={e => handleRegister(e)}
            >
              Register
            </button>
            <div className="login-or-row">
              <span>OR</span>
            </div>
            <div className="dont-have-row">
              Already have an account?
              <span
                className="link-label text-decoration-underline"
                onClick={() => props.history.push("/login")}
              >
                Login Now
              </span>
            </div>
            {/* <div
              className="text-center link-label"
              onClick={() => props.history.push("/login")}
            >
              Login ?
            </div> */}
          </form>
        </div>
        {loading && <Loader />}
        {otpModal && (
          <Modal isOpen={otpModal} backdrop={true} centered>
            {otpModal && (
              <OTPModal
                closeModal={closeModal}
                merchant={registeredUser}
                isResendRequest={false}
              />
            )}
          </Modal>
        )}
      </div>
      <SideImage />
    </div>
    // <div className="container-fluid" style={loginContainer}>
    //   <div className="form-align">
    //   </div>

    // </div>
  );
};

export default compose(withRouter, RegisterEnhancer)(Register);
